var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { atom } from 'jotai';
import InkyAPI from '../API/InkyAPI';
import { ApiError, ApiErrorStatus, InkyApiV2 } from '../API/InkyApiV2';
import { AccountInfo, SignupResponseStatus } from '../Models/AccountInfo';
import { InkyDashApiV2 } from '../API/InkyDashApiV2';
import { CheckoutOverlayVisible, LoginOverlayVisible, LoginType, LoginTypeStore } from './OverlayStore';
import CreateUserPayload from '../Models/CreateUserPayload';
import { atomWithStorage } from 'jotai/utils';
import { AxiosError } from 'axios';
import { MyBooksAtom } from './MyBooksStore';
import { FetchCartAtom } from './CartStore';
var InkyApi = InkyApiV2.shared();
var InkyDashApi = InkyDashApiV2.shared();
export var LoginStatusAtom = atom("Unknown");
export var AccountInfoAtom = atom(new AccountInfo());
export var ForgotPasswordTimerAtom = atom(0);
export var MatureContentWarningAccepted = atomWithStorage('MatureContentWarningAccepted', false);
//region Accesstoken
function setAccessToken(accessToken) {
    InkyApi.AccessToken = accessToken;
    InkyDashApi.AccessToken = accessToken;
}
var PersistentAccessTokenAtom = atom('');
export var AccessTokenAtom = atom(function (get) {
    var storedValue = get(PersistentAccessTokenAtom);
    if (storedValue) {
        return get(PersistentAccessTokenAtom);
    }
}, function (get, set, newAccessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var currentNewAccessToken, accountInfo, e_1, refreshToken, newAccessToken_1, accountInfo, e_2, e_3, refreshToken, newAccessToken_2, accountInfo, e_4, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentNewAccessToken = newAccessToken;
                // If we unset the access-token we intend to log out
                if (currentNewAccessToken == null) {
                    set(PersistentAccessTokenAtom, null); // Set the reference to null
                    localStorage.removeItem('AccessToken'); // Remove the persistent storage
                    setAccessToken(null); // Also tell the legacy api that we dont have a accesstoken anymore
                    set(LoginStatusAtom, "LoggedOut"); // We can set the loginstatus to logged out
                    return [2 /*return*/];
                }
                // Update the AccessToken in the InkyAPi Singleton
                setAccessToken(currentNewAccessToken);
                if (!(currentNewAccessToken !== null)) return [3 /*break*/, 16];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 15]);
                return [4 /*yield*/, InkyApi.FetchAccountInfo()];
            case 2:
                accountInfo = _a.sent();
                set(AccountInfoAtom, accountInfo);
                return [3 /*break*/, 15];
            case 3:
                e_1 = _a.sent();
                console.warn('[AccountStore] Could not validate AccountInfo', e_1);
                if (!(e_1 instanceof ApiError)) return [3 /*break*/, 13];
                if (!(e_1.status == ApiErrorStatus.InvalidAccessToken)) return [3 /*break*/, 12];
                _a.label = 4;
            case 4:
                _a.trys.push([4, 11, , 12]);
                refreshToken = localStorage.getItem('RefreshToken');
                return [4 /*yield*/, InkyApi.LoginWithRefreshTokenFromLocalStorage(refreshToken)];
            case 5:
                newAccessToken_1 = _a.sent();
                currentNewAccessToken = newAccessToken_1.access_token;
                setAccessToken(currentNewAccessToken);
                _a.label = 6;
            case 6:
                _a.trys.push([6, 9, , 10]);
                return [4 /*yield*/, InkyApi.FetchAccountInfo()];
            case 7:
                accountInfo = _a.sent();
                set(AccountInfoAtom, accountInfo);
                return [4 /*yield*/, set(AccessTokenAtom, InkyApi.AccessToken)];
            case 8:
                _a.sent();
                return [3 /*break*/, 10];
            case 9:
                e_2 = _a.sent();
                console.error('Failed setting account-info twice.', e_2);
                console.error(e_2);
                return [3 /*break*/, 10];
            case 10: return [3 /*break*/, 12];
            case 11:
                e_3 = _a.sent();
                console.error('Api Error', e_3);
                return [3 /*break*/, 12];
            case 12: return [3 /*break*/, 14];
            case 13:
                console.error('Something went wrong while requesting accountinfo', e_1);
                throw (e_1);
            case 14: return [3 /*break*/, 15];
            case 15:
                if (currentNewAccessToken === undefined) {
                    // if we somehow can't fetch the access token with refresh token
                    set(LoginStatusAtom, "LoggedOut");
                    localStorage.removeItem('AccessToken');
                    set(PersistentAccessTokenAtom, newAccessToken);
                }
                else {
                    if (LoginTypeStore.getLoginType() === LoginType.Checkout) {
                        set(LoginOverlayVisible, false); // Disables the loginOverlauy
                        set(CheckoutOverlayVisible, true);
                    }
                    localStorage.setItem('AccessToken', currentNewAccessToken);
                    set(LoginStatusAtom, "LoggedIn");
                    set(PersistentAccessTokenAtom, currentNewAccessToken);
                }
                return [3 /*break*/, 24];
            case 16:
                _a.trys.push([16, 23, , 24]);
                refreshToken = localStorage.getItem('RefreshToken');
                if (refreshToken == null) {
                    console.debug('[Account] Client does not possess neither accessToken or refreshToken, cancelling login.');
                    set(LoginStatusAtom, "LoggedOut");
                    return [2 /*return*/];
                }
                return [4 /*yield*/, InkyApi.LoginWithRefreshTokenFromLocalStorage(refreshToken)];
            case 17:
                newAccessToken_2 = _a.sent();
                currentNewAccessToken = newAccessToken_2.access_token;
                setAccessToken(currentNewAccessToken);
                _a.label = 18;
            case 18:
                _a.trys.push([18, 21, , 22]);
                return [4 /*yield*/, InkyApi.FetchAccountInfo()];
            case 19:
                accountInfo = _a.sent();
                set(AccountInfoAtom, accountInfo);
                return [4 /*yield*/, set(AccessTokenAtom, InkyApi.AccessToken)];
            case 20:
                _a.sent();
                return [3 /*break*/, 22];
            case 21:
                e_4 = _a.sent();
                console.error('Failed setting account-info twice.', e_4);
                console.error(e_4);
                return [3 /*break*/, 22];
            case 22:
                if (currentNewAccessToken === undefined) {
                    // if we somehow can't fetch the access token with refresh token
                    set(LoginStatusAtom, "LoggedOut");
                    localStorage.removeItem('AccessToken');
                }
                else {
                    if (LoginTypeStore.getLoginType() === LoginType.Checkout) {
                        set(LoginOverlayVisible, false); // Disables the loginOverlauy
                        set(CheckoutOverlayVisible, true);
                    }
                    localStorage.setItem('AccessToken', currentNewAccessToken);
                    set(LoginStatusAtom, "LoggedIn");
                    set(PersistentAccessTokenAtom, currentNewAccessToken);
                }
                return [3 /*break*/, 24];
            case 23:
                e_5 = _a.sent();
                console.error('Api Error', e_5);
                set(LoginStatusAtom, "LoggedOut");
                localStorage.removeItem('AccessToken');
                set(PersistentAccessTokenAtom, newAccessToken);
                return [3 /*break*/, 24];
            case 24: 
            // LoginTypeStore.setLoginType(LoginType.Normal);
            return [4 /*yield*/, set(FetchCartAtom)];
            case 25:
                // LoginTypeStore.setLoginType(LoginType.Normal);
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
AccessTokenAtom.onMount = function (set) {
    console.log('Loading accesstoken');
    set(localStorage.getItem('AccessToken'));
};
//endregion
//region RefreshToken
function setRefreshToken(refreshToken) {
    InkyApi.RefreshToken = refreshToken;
    InkyDashApi.RefreshToken = refreshToken;
}
var PersistentRefreshToken = atom('');
export var RefreshTokenAtom = atom(function (get) {
    var storedValue = get(PersistentRefreshToken);
    if (storedValue) {
        return get(PersistentRefreshToken);
    }
}, function (get, set, refreshToken) {
    set(PersistentRefreshToken, refreshToken);
    setRefreshToken(refreshToken);
    if (refreshToken != null) {
        localStorage.setItem('RefreshToken', refreshToken);
        set(LoginStatusAtom, "LoggedIn");
    }
    else {
        set(LoginStatusAtom, "LoggedOut");
        localStorage.removeItem('RefreshToken');
    }
});
RefreshTokenAtom.onMount = function (set) {
    set(localStorage.getItem('RefreshToken'));
};
export var LoginErrorMessageAtom = atom(false);
export var LoginAtom = atom(function (get) { return get(LoginStatusAtom); }, function (get, set, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var loginResponse, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                set(LoginStatusAtom, "LoggingIn");
                set(LoginErrorMessageAtom, false);
                if (!payload.email || !payload.password) {
                    set(LoginStatusAtom, "LoggedOut");
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, InkyAPI.login(payload.email, payload.password)];
            case 2:
                loginResponse = _a.sent();
                if (loginResponse.refresh_token != null) {
                    set(AccessTokenAtom, loginResponse.access_token);
                    set(RefreshTokenAtom, loginResponse.refresh_token);
                    setAccessToken(loginResponse.access_token);
                    set(LoginStatusAtom, "LoggedIn");
                }
                return [3 /*break*/, 4];
            case 3:
                e_6 = _a.sent();
                if (e_6 instanceof AxiosError) {
                    if (e_6.response.status === 403) {
                        set(LoginErrorMessageAtom, 'Wrong password.');
                    }
                    console.log('Network error!', e_6);
                }
                else {
                    console.error('Unknown error', e_6);
                }
                set(LoginStatusAtom, "LoggedOut");
                return [3 /*break*/, 4];
            case 4: return [4 /*yield*/, set(FetchCartAtom)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
//endregion
//region Logout
export var LogoutAtom = atom(function (get) {
    get(LoginStatusAtom);
}, function (get, set) {
    // localStorage.removeItem('AccessToken');
    var accountInfo = get(AccountInfoAtom);
    if (accountInfo.roles) {
        accountInfo = __assign(__assign({}, accountInfo), { roles: accountInfo.roles.filter(function (role) { return role !== 'admin'; }) });
        set(AccountInfoAtom, accountInfo);
    }
    set(RefreshTokenAtom, null);
    set(AccessTokenAtom, null);
    localStorage.removeItem('forgot_password');
    set(AccountInfoAtom, new AccountInfo());
    set(MyBooksAtom, []);
});
//endregion
//region SignUp
export var SignUpStatus = atom(false);
export var SignUpActionAtom = atom(function (get) { return get(SignUpStatus); }, function (get, set, update) { return __awaiter(void 0, void 0, void 0, function () {
    var signupResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('[SignUp] Attempting to register new account.');
                return [4 /*yield*/, InkyApiV2.shared().Signup(new CreateUserPayload(update.email, update.password))];
            case 1:
                signupResponse = _a.sent();
                switch (signupResponse) {
                    case SignupResponseStatus.Successful:
                        // Log user in
                        set(LoginAtom, { email: update.email, password: update.password });
                        set(SignUpStatus, signupResponse);
                        break;
                    case SignupResponseStatus.TenantError:
                        // Update the status. Signup will re-render and show error message
                        set(SignUpStatus, signupResponse);
                        break;
                    case SignupResponseStatus.InvalidEmail:
                        // Update the status. Signup wil re-render and show error message
                        set(SignUpStatus, signupResponse);
                        break;
                    case SignupResponseStatus.UnknownError:
                        // Update the status. Signup wil re-render and show error message
                        set(SignUpStatus, signupResponse);
                        break;
                }
                return [2 /*return*/];
        }
    });
}); });
//endregion
//region Admin-stores
export var AdminBuyPass = atomWithStorage('AdminBuyPass', false);
//endregion
